import { Injectable } from '@angular/core';
import { EntityState, EntityStore, getEntityType, StoreConfig } from '@datorama/akita';

import { DriverSiteGroup } from '@shared/services/gql.service';

export type SiteCurveModel = getEntityType<SiteCurveState>;

export type SiteCurveState = EntityState<
  DriverSiteGroup & {
    showLine: boolean;
    site_group_id: string;
    site_group_ids: string[];
  }
>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ idKey: 'driver_setting_id', name: 'site-curve' })
export class SiteCurveStore extends EntityStore<SiteCurveState> {
  constructor() {
    super({});
  }
}
